import React from 'react'
import Modal from 'components/Modal'
import { ActionButton } from 'components/Buttons'
import { put } from 'services/api/api'
import { env } from 'components/Helpers'

const curr = new Date()
curr.setDate(curr.getDate() + 1)
const date = curr.toISOString().substr(0, 10)

// The operator's support_pin SMS template for the member's locale; null when there is none
// or it can't be read (e.g. without memberships.use_templates)
const fetchTemplate = (locale) => {
  const url = `https://memberships.${env()}.credlock.net/api/templates/sms/type/support_pin/locale/${encodeURIComponent(locale)}`
  const headers = { Accept: 'application/json', Authorization: `Bearer ${window.localStorage.getItem('auth-token')}` }

  return fetch(url, { headers })
    .then((res) => res.ok ? res.json() : {})
    .then((res) => (res.data && res.data.text) || null)
    .catch(() => null)
}

// The built-in message, used without an operator template
const defaultMessage = (locale) => {
  if (locale === 'nb-NO') {
    return 'Hei $firstName! Din EVO PIN-kode er: $pinCode, husk å avslutte med #. PIN-koden er gyldig til $pinValidTo. God trening! Mvh EVO'
  }
  return 'Hallo $firstName! Dein EVO-PIN-Code lautet: $pinCode (mit # abschließen). Der PIN-Code ist gültig bis zum $pinValidTo. Mit freundlichen Grüßen, EVO Fitness'
}

const Success = ({ onClose, response }) => {
  return (
    <Modal>
      <h1 className='modal-header'>Support PIN sent</h1>
      <div className='model-content' style={{ margin: '3em 5em', textAlign: 'center' }}>
        <p style={{ marginBottom: '3em' }}>
          Code: {response.code}
        </p>
        <ActionButton txt='Close' onClick={onClose} />
      </div>
    </Modal>
  )
}

const Error = ({ onClose, response }) => {
  return (
    <Modal>
      <h1 className='modal-header'>Support PIN not sent</h1>
      <div className='model-content' style={{ margin: '3em 5em', textAlign: 'center' }}>
        <p style={{ marginBottom: '3em' }}>
          Error: {response.message || 'Something went wrong...'}
        </p>
        <ActionButton txt='Close' onClick={onClose} />
      </div>
    </Modal>
  )
}

const SupportPinModal = ({ onClose, membership }) => {
  const [body, setBody] = React.useState({
    valid_to: date,
    message: defaultMessage(membership.locale),
    first_name: membership.customer.first_name
  })

  const [response, setResponse] = React.useState(null)
  // The message to start from: the operator's template, else the built-in text; null while loading
  const [template, setTemplate] = React.useState(null)

  React.useEffect(() => {
    fetchTemplate(membership.locale).then((text) => {
      const start = text || defaultMessage(membership.locale)
      setBody((current) => ({ ...current, message: start }))
      setTemplate(start)
    })
  }, [membership.locale])

  const sendPin = () => {
    return put(`memberships/${membership.id}/pin`, body)
      .then(setResponse)
  }

  const onChange = (event) => {
    const { value, name } = event.target
    setBody((current) => ({ ...current, [name]: value }))
  }

  if (response && response.code) return <Success response={response} onClose={onClose} />
  if (response && !response.code) return <Error response={response} onClose={onClose} />

  return (
    <Modal>
      <h1 className='modal-header'>Support PIN</h1>
      <div className='model-content' style={{ margin: '3em 5em' }}>
        <form onSubmit={sendPin} style={{ lineHeight: '20px' }}>
          <div style={{ marginBottom: '1em' }}>
            <label style={{ marginBottom: 0 }}>Valid to:</label>
            <input
              name='valid_to'
              type='date'
              defaultValue={body.valid_to}
              onChange={onChange}
            />
          </div>
          <div style={{ marginBottom: '1em' }}>
            <label style={{ marginBottom: 0 }}>Message:</label>
            <textarea
              name='message'
              style={{ width: '100%', height: '10em', lineHeight: '20px' }}
              key={template === null ? 'loading' : 'loaded'}
              defaultValue={template || body.message}
              disabled={template === null}
              onChange={onChange}
            />
          </div>
        </form>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <ActionButton
            txt='Cancel'
            onClick={onClose}
          />
          <ActionButton
            txt='Send message'
            onClick={sendPin}
          />
        </div>
      </div>
    </Modal>
  )
}

export default SupportPinModal
